import { getArtistPersonId } from '../getArtistPersonId/getArtistPersonId';
import { Config } from '#lib/constants/config.js';
import { GlobalRoutes } from '#lib/features/navigation/constants/global-routes.js';
import { getImageUrl } from '$global/utils/getImageUrl/getImageUrl';
import { omitEmpty } from '$global/utils/omitEmpty/omitEmpty';
import { stripMarkdown } from '$global/utils/stripMarkdown/stripMarkdown';

// Optional fields so both the REST and GraphQL-loaded artist satisfy it.
type ArtistJsonLdInput = {
	slug: string;
	name?: string | null;
	bio_short?: string | null;
	image?: { filename_disk?: string | null } | null;
	official_website_link?: string | null;
	instagram_link?: string | null;
	facebook_link?: string | null;
	twitter_link?: string | null;
};

export const getArtistJsonLd = (artist: ArtistJsonLdInput) =>
	omitEmpty({
		'@context': 'https://schema.org',
		'@type': 'Person',
		'@id': getArtistPersonId(artist.slug),
		url: `${Config.Domain}${GlobalRoutes.ArtistsHome}/${artist.slug}`,
		name: artist.name,
		// Only bio_short is rendered on the page.
		description: stripMarkdown(artist.bio_short ?? '').trim(),
		image: getImageUrl(artist.image?.filename_disk, '1024px'),
		sameAs: [
			artist.official_website_link,
			artist.instagram_link,
			artist.facebook_link,
			artist.twitter_link,
		].filter(Boolean),
	});
